module.exports = __webpack_public_path__ + "img/frame (57).b6ef0dd0.jpg";